import { Colors, MEDIA } from '@brg/ui';
import styled from 'styled-components';

export const ModalContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: fixed;
    top: -48px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(21, 21, 20, 0.64);
    backdrop-filter: blur(12px);
    width: 100vw;
    height: 100dvh;
    @supports (-webkit-touch-callout: none) {
        height: calc(-webkit-fill-available + 48px);
    }
`;

export const ModalContent = styled.div`
    width: 100vw;
    max-width: 100vw;
    background-color: ${Colors.galBlack5};
    padding: 16px 16px 40px 16px;
    border-radius: 8px 8px 0 0;
    text-align: center;
    padding-bottom: max(40px, env(safe-area-inset-bottom, 20px));
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
    @supports (-webkit-touch-callout: none) {
        max-height: calc(-webkit-fill-available - 48px);
    }
`;
export const CloseIconWrapper = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    margin-left: auto;
`
export const TextWrapper = styled.div`
    margin-bottom: 24px;
    display: flex;
    width: 100%;
    gap: 8px;
`;

export const StyledH2 = styled.h2`
    text-align: start;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    margin: 0;
    color: ${Colors.galBlack100};
`;

export const StyledP = styled.p`
    text-align: start;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.1px;
    margin: 8px 0 0 0;
    color: ${Colors.galBlack100};
`;

export const ButtonGroup = styled.div`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    gap: 8px;
`;

export const CancelButton = styled.button`
    flex: 1;
    background-color: transparent;
    color: ${Colors.galBlack100};
    padding: 10px 24px;
    border: 1px solid ${Colors.galBlack100};
    border-radius: 3px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &:focus {
        outline: none;
    }
`;

export const SaveButton = styled.button`
    flex: 1;
    background-color: ${Colors.galBlack100};
    color: #ffffff;
    padding: 10px 24px;
    border: none;
    border-radius: 3px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #343434;
    }

    &:focus {
        outline: none;
    }
`;import { Colors, MEDIA } from '@brg/ui';
import styled from 'styled-components';

export const ModalContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: fixed;
    top: -48px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(21, 21, 20, 0.64);
    backdrop-filter: blur(12px);
    width: 100vw;
    height: 100dvh;
    @supports (-webkit-touch-callout: none) {
        height: calc(-webkit-fill-available + 48px);
    }
`;

export const ModalContent = styled.div`
    width: 100vw;
    max-width: 100vw;
    background-color: ${Colors.galBlack5};
    padding: 16px 16px 40px 16px;
    border-radius: 8px 8px 0 0;
    text-align: center;
    padding-bottom: max(40px, env(safe-area-inset-bottom, 20px));
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
    @supports (-webkit-touch-callout: none) {
        max-height: calc(-webkit-fill-available - 48px);
    }
`;
export const CloseIconWrapper = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    margin-left: auto;
`
export const TextWrapper = styled.div`
    margin-bottom: 24px;
    display: flex;
    width: 100%;
    gap: 8px;
`;

export const StyledH2 = styled.h2`
    text-align: start;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    margin: 0;
    color: ${Colors.galBlack100};
`;

export const StyledP = styled.p`
    text-align: start;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.1px;
    margin: 8px 0 0 0;
    color: ${Colors.galBlack100};
`;

export const ButtonGroup = styled.div`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    gap: 8px;
`;

export const CancelButton = styled.button`
    flex: 1;
    background-color: transparent;
    color: ${Colors.galBlack100};
    padding: 10px 24px;
    border: 1px solid ${Colors.galBlack100};
    border-radius: 3px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &:focus {
        outline: none;
    }
`;

export const SaveButton = styled.button`
    flex: 1;
    background-color: ${Colors.galBlack100};
    color: #ffffff;
    padding: 10px 24px;
    border: none;
    border-radius: 3px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #343434;
    }

    &:focus {
        outline: none;
    }
`;